
    import Sortable from "sortablejs";

    const highlightDropZones = (sourceZone) => {
      document.querySelectorAll(".js-approval-drop-zone").forEach((el) => {
        el.classList.toggle("drop-zone-active", el !== sourceZone);
      });
    };

    const clearDropZones = () => {
      document.querySelectorAll(".js-approval-drop-zone").forEach((el) => {
        el.classList.remove("drop-zone-active");
      });
    };

    export default {
      mounted() {
        this.sortable = Sortable.create(this.el, {
          group: "approval-users",
          draggable: ".user-tile",
          handle: ".drag-handle",
          sort: false,
          animation: 150,
          ghostClass: "opacity-50",
          onStart: (evt) => highlightDropZones(evt.from.closest(".js-approval-drop-zone")),
          onEnd: (evt) => {
            clearDropZones();

            const userPracticeId = evt.item.dataset.userPracticeId;
            const newGroup = evt.to.dataset.group;
            const oldGroup = evt.from.dataset.group;
            if (newGroup !== oldGroup) {
              this.pushEventTo(this.el, "move-user", {
                user_practice_id: userPracticeId,
                new_group: newGroup,
              });
            }
          },
        });
      },
      destroyed() {
        this.sortable?.destroy();
      },
    };
  